// @flow
import ReportGenerate from './ReportGenerate';

export default ReportGenerate;
